import axios from "axios";

import { baseAxios } from "config";

const updateAvailabilityBulk = async ({ slots }) => {
  const res = await baseAxios.put(`/availability/bulk`, { slots });
  return res.data;
};

export default updateAvailabilityBulk;
